import React from "react";
import "../assets/index.scss";
import "../assets/typography.scss";

const ContactPage = () => {
    return (
        <div className="comingsoon">
            <h1 className="heading-1">Coming Soon!</h1>
        </div>
    );
};

export default ContactPage;
